export const TEST_ID = 'accountDetails';
